import { FETCH_PROFILES, FETCH_PROFILES_USER, CREATE_PROFILE, UPDATE_PROFILE, DELETE_PROFILE, FETCH_PROFILE_BY_USER, START_LOADING, END_LOADING, FETCH_PROFILE } from './constants';
import * as api from '../api/index.js';

export const getProfile = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchProfile(id);

    dispatch({ type: FETCH_PROFILE, payload: data });


    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const getProfiles = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data } = await api.fetchProfiles();
    dispatch({ type: FETCH_PROFILES, payload: data });
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error);
  }
};

export const getProfilesByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = api.fetchProfilesByUser(searchQuery)
    dispatch({ type: FETCH_PROFILE_BY_USER, payload: data });
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response)
  }
};

export const getProfilesBySearch = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data: { data } } = await api.fetchProfilesBySearch(searchQuery);
    dispatch({ type: FETCH_PROFILES_USER, payload: { data } });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error);
  }
};

export const createProfile = (profile, history) => async (dispatch) => {
  try {
    const { data } = await api.createProfile(profile);
    dispatch({ type: CREATE_PROFILE, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateProfile = (id, form, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateProfile(id, form);
    dispatch({ type: UPDATE_PROFILE, payload: data });
    const profile = JSON.parse(localStorage.getItem('profile'));
    if (profile?.userProfile?._id === data?._id) {
      profile.userProfile = { ...profile.userProfile, ...data };
      localStorage.setItem('profile', JSON.stringify(profile));
    }
    // Company settings are now server-authoritative via CompanyModel, no profileDetail in localStorage
    localStorage.removeItem("profileDetail");
    openSnackbar("Profile updated successfully");
    return data;
  } catch (error) {
    console.log(error);
    openSnackbar(error?.response?.data?.message || "Failed to update profile");
    return null;
  }
};


export const deleteProfile = (id) => async (dispatch) => {
  try {
   await api.deleteProfile(id);

    dispatch({ type: DELETE_PROFILE, payload: id });
  } catch (error) {
    console.log(error);
  }
};
